// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropzoneBlock__RXuPM {
  width: 100%;
  padding: 20px;
}

.emptyBlock__IlBvY {
  height: 100%;
  display: flex;
}

.dropzoneBlockContainer__dVAGA {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  text-transform: uppercase;
  border: 1px dashed var(--buttons-surface);
  padding: 10px;
  gap: 20px;
}

.disabledDropzoneBlockContainer__pBgeq {
  border: 1px dashed var(--buttons-disable);
}

.dropzoneBlockPreview__yVXkS {
  display: grid;
  align-items: center;
  grid-template-columns: repeat(6, 1fr);
  grid-gap: 15px;
  margin-top: 20px;
}

.supportTypesBlock__zEEnY {
  font-size: 12px;
  line-height: 14px;
  color: var(--inputs-disable-text);
  max-width: 400px;
}

.btnWrapper__yfjwu {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
}

.btnInlineWrapper__JknZx {
  justify-content: center;
  gap: unset;
}

.dropZoneBlockTitle__hMPdL {
  color: var(--tables-title-text);
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px;
  text-transform: uppercase;
  margin: unset;
}
.dropZoneBlockTitle__hMPdL p {
  margin: 5px;
}
.dropZoneBlockTitle__hMPdL span {
  display: block;
}

.dropZoneInlineTitle__ISLOW {
  display: flex;
  align-items: center;
  gap: 5px;
}

.photoBtn__p3zPj {
  width: 76px;
  height: 64px;
  margin-left: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px dashed var(--buttons-surface);
  cursor: pointer;
}
.photoBtn__p3zPj svg path {
  stroke: var(--buttons-surface);
}

.photoBtnText__cEsFE {
  font-size: 12px;
  line-height: 12px;
  color: var(--buttons-surface);
  margin-top: 5px;
}`, "",{"version":3,"sources":["webpack://./../src/components/modals/AttachFilesModal/components/Dropzone/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,WAAA;EACA,aAAA;AAzEF;;AA4EA;EACE,YAAA;EACA,aAAA;AAzEF;;AA4EA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,yCAAA;EACA,aAAA;EACA,SAAA;AAzEF;;AA4EA;EACE,yCAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,mBAAA;EACA,qCAAA;EACA,cAAA;EACA,gBAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,iBAAA;EACA,iCAAA;EACA,gBAAA;AAzEF;;AA4EA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;AAzEF;;AA4EA;EACE,uBAAA;EACA,UAAA;AAzEF;;AA6EA;EACE,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,aAAA;AA1EF;AA4EE;EACE,WAAA;AA1EJ;AA6EE;EACE,cAAA;AA3EJ;;AA+EA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AA5EF;;AA+EA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,yCAAA;EACA,eAAA;AA5EF;AA+EI;EACE,8BAAA;AA7EN;;AAkFA;EACE,eAAA;EACA,iBAAA;EACA,6BAAA;EACA,eAAA;AA/EF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.dropzoneBlock {\n  width: 100%;\n  padding: 20px;\n}\n\n.emptyBlock {\n  height: 100%;\n  display: flex;\n}\n\n.dropzoneBlockContainer {\n  width: 100%;\n  height: auto;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  text-transform: uppercase;\n  border: 1px dashed var(--buttons-surface);\n  padding: 10px;\n  gap: 20px;\n}\n\n.disabledDropzoneBlockContainer {\n  border: 1px dashed var(--buttons-disable);\n}\n\n.dropzoneBlockPreview {\n  display: grid;\n  align-items: center;\n  grid-template-columns: repeat(6, 1fr);\n  grid-gap: 15px;\n  margin-top: 20px;\n}\n\n.supportTypesBlock {\n  font-size: 12px;\n  line-height: 14px;\n  color: var(--inputs-disable-text);\n  max-width: 400px;\n}\n\n.btnWrapper {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 20px;\n}\n\n.btnInlineWrapper {\n  justify-content: center;\n  gap: unset;\n\n}\n\n.dropZoneBlockTitle {\n  color: var(--tables-title-text);\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 14px;\n  text-transform: uppercase;\n  margin: unset;\n\n  p {\n    margin: 5px;\n  }\n\n  span {\n    display: block;\n  }\n}\n\n.dropZoneInlineTitle {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.photoBtn {\n  width: 76px;\n  height: 64px;\n  margin-left: 8px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  border: 1px dashed var(--buttons-surface);\n  cursor: pointer;\n\n  svg {\n    path {\n      stroke: var(--buttons-surface);\n    }\n  }\n}\n\n.photoBtnText {\n  font-size: 12px;\n  line-height: 12px;\n  color: var(--buttons-surface);\n  margin-top: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dropzoneBlock": `dropzoneBlock__RXuPM`,
	"emptyBlock": `emptyBlock__IlBvY`,
	"dropzoneBlockContainer": `dropzoneBlockContainer__dVAGA`,
	"disabledDropzoneBlockContainer": `disabledDropzoneBlockContainer__pBgeq`,
	"dropzoneBlockPreview": `dropzoneBlockPreview__yVXkS`,
	"supportTypesBlock": `supportTypesBlock__zEEnY`,
	"btnWrapper": `btnWrapper__yfjwu`,
	"btnInlineWrapper": `btnInlineWrapper__JknZx`,
	"dropZoneBlockTitle": `dropZoneBlockTitle__hMPdL`,
	"dropZoneInlineTitle": `dropZoneInlineTitle__ISLOW`,
	"photoBtn": `photoBtn__p3zPj`,
	"photoBtnText": `photoBtnText__cEsFE`
};
module.exports = ___CSS_LOADER_EXPORT___;
